import { render, staticRenderFns } from "./codSettingList.vue?vue&type=template&id=e5aa008c&scoped=true"
import script from "./codSettingList.vue?vue&type=script&lang=js"
export * from "./codSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aa008c",
  null
  
)

export default component.exports